import { Badge, Button, Card, Group, Image } from '@mantine/core';
import classnames from 'classnames';

import styles from './ButtonImageCard.module.scss';
import { Props } from './ButtonImageCard.types';

const ButtonImageCard = ({
  title,
  image,
  buttonLabel,
  badgeText,
  onClick,
  text,
  loading,
  disabled,
  deemphasized,
}: Props) => {
  return (
    <Card
      shadow="sm"
      padding="lg"
      radius="md"
      withBorder
      className={classnames(styles.card, { [styles.deemphasized]: deemphasized })}
    >
      {image && (
        <Card.Section>
          <Image src={image} height={300} />
        </Card.Section>
      )}
      <Group justify="space-between" mt="md" mb="xs">
        <div className={styles.title}>{title}</div>
        {badgeText && <Badge color="pink">{badgeText}</Badge>}
      </Group>

      <div className={styles.text}>{text}</div>

      <Button
        className={styles.button}
        fullWidth
        onClick={onClick}
        loading={loading}
        disabled={disabled}
      >
        {buttonLabel}
      </Button>
    </Card>
  );
};

export default ButtonImageCard;
